module.exports = __webpack_public_path__ + "img/result_tips.533d67c1.png";